import React, { FC } from "react"
import { Box, Grid, Typography } from "@mui/material"
import {
  HasSidebarLayout,
  DataLoad,
  ListHeader,
  CollapsibleSection,
  ProjectDashboard,
  SensorDashboard,
  RapidRHSensorDashboard,
  ProductDashboard,
  ManufacturerAnnouncementDashboard,
  UsageStatisticsDashboard,
  ProjectTypeDashboard,
  ProjectBuildingTypeDashboard,
  EventDashboard,
  ContractorsAssignmentDashboard,
} from "src/components"
import { useDashboardRequest } from "src/hooks/api"
import { DashboardStatistics } from "src/api"
import { DataLoggerDashboard } from "src/components/sections/dashboard/dataLoggerDashboard"

interface DashboardContentProps {
  dashboard: DashboardStatistics | null;
}

const DashboardContent: FC<DashboardContentProps> = ({
  dashboard,
}) => {
  if (!dashboard) {
    return (
      <Grid container direction="column" spacing={3}>
        <Grid item>
          <Typography variant="body2">There is no statistics information</Typography>
        </Grid>
      </Grid>
    )
  }

  return (
    <Grid container direction="column" spacing={3} wrap="nowrap">
      <Grid item>
        <CollapsibleSection title="Projects">
          <ProjectDashboard projectStatistics={dashboard.project} />
        </CollapsibleSection>
      </Grid>
      <Grid item>
        <CollapsibleSection title="CLīMIT Sensors">
          <SensorDashboard sensorStatistics={dashboard.sensor} />
        </CollapsibleSection>
      </Grid>
      <Grid item>
        <CollapsibleSection title="RapidRH Sensors">
          <RapidRHSensorDashboard rapidRHSensorStatistics={dashboard.rapidRHSensor} />
        </CollapsibleSection>
      </Grid>
      <Grid item>
        <CollapsibleSection title="DataPUCK Sensors">
          <DataLoggerDashboard dataLoggerStatistics={dashboard.dataLogger} />
        </CollapsibleSection>
      </Grid>
      <Grid item>
        <CollapsibleSection title="Products">
          <ProductDashboard productStatistics={dashboard.product} />
        </CollapsibleSection>
      </Grid>
      <Grid item>
        <CollapsibleSection title="GangBox">
          <ManufacturerAnnouncementDashboard manufacturerAnnouncementStatistics={dashboard.manufacturerAnnouncement} />
        </CollapsibleSection>
      </Grid>
      <Grid item>
        <CollapsibleSection title="Usage Statistics">
          <UsageStatisticsDashboard usageStatistics={dashboard.usageStatistics} />
        </CollapsibleSection>
      </Grid>
      <Grid item>
        <CollapsibleSection title="Project Types">
          <ProjectTypeDashboard projectTypeStatistics={dashboard.projectTypes} projectsNumber={dashboard.project.projectsNumber} />
        </CollapsibleSection>
      </Grid>
      <Grid item>
        <CollapsibleSection title="Building Types">
          <ProjectBuildingTypeDashboard projectBuildingTypeStatistics={dashboard.projectBuildingTypes} projectsNumber={dashboard.project.projectsNumber} />
        </CollapsibleSection>
      </Grid>
      <Grid item>
        <CollapsibleSection title="Job File Events">
          <EventDashboard eventStatistics={dashboard.event} />
        </CollapsibleSection>
      </Grid>
      <Grid item>
        <CollapsibleSection title="Contractors assignment">
          <ContractorsAssignmentDashboard contractorsAssignment={dashboard.contractorsAssignment || []} />
        </CollapsibleSection>
      </Grid>
    </Grid>
  )
}

const Dashboard: FC = () => {
  document.title = 'CLīMIT Admin Panel - Dashboard'
  const { data, isInitialLoading, isError, error } = useDashboardRequest()

  return (
    <HasSidebarLayout>
      <Box mb={2}>
        <ListHeader title="Dashboard" />
      </Box>
      <DataLoad
        isLoading={isInitialLoading}
        isError={isError}
        errorMessage={error?.message}
      >
        <DashboardContent
          dashboard={data || null}
        />
      </DataLoad>
    </HasSidebarLayout>
  )
}

export default Dashboard
